export default {
  columnOptions: "Spaltenoptionen",
  rowsPerPage: "Zeilen pro Seite",
  search: "Suche",
};
